import { Component, OnInit, isDevMode, ViewChild, ElementRef } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ShopRidesService } from '../../../../services/shoprides.service';
import { RentalsService } from '../../../../services/rentals.service';
import { HelpersService } from '../../../../services/helpers.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfig } from '../../../../app.config';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-shop-rides-configuration',
  templateUrl: './shop-rides-configuration.component.html',
  styleUrls: ['./shop-rides-configuration.component.scss'],
})
export class ShopRidesConfigurationComponent implements OnInit {
  public configForm: FormGroup;
  public config: any = {};
  public parentIdentifier: string = '';
  public partnerIdentifier: string = '';
  public loading: boolean = false;
  public saving: boolean = false;
  public iFrameCreated: boolean = false;
  public dangerousURL: string;
  public iFrameLink: SafeResourceUrl | string;
  public iFrameSizer: SafeResourceUrl | string;
  public selectedCategoryRideType: any;
  public selectedProductRideType: any;
  public productCategories: any = [];
  public selectedProductCategory: any;
  public productGroups: any = [];
  public selectedProductGroup: any;
  public linkedCategories : any = [];
  public linkedProducts : any = [];
  public linkingRentalCategory: boolean = false;
  public linkingProduct: boolean = false;

  @ViewChild('additionalInfoEditor') quillEditor: ElementRef;
  public additionalInformation: string = '';
  public modules = {
    toolbar: [
      ['bold', 'italic', 'underline'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'], // outdent/indent
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      ['clean'], // remove formatting button
    ],
  };

  public fontOptions = [
    {
      value: 'Roboto',
      url: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600&display=swap',
    },
    {
      value: 'Lato',
      url: 'https://fonts.googleapis.com/css2?family=Lato:wght@400;500;600&display=swap',
    },
    {
      value: 'Lora',
      url: 'https://fonts.googleapis.com/css2?family=Lora:wght@400;500;600&display=swap',
    },
    {
      value: 'Inter',
      url: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap',
    },
    {
      value: 'Encode Sans',
      url: 'https://fonts.googleapis.com/css2?family=Encode+Sans:wght@400;500;600&display=swap',
    },
    {
      value: 'Manrope',
      url: 'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600&display=swap',
    },
    {
      value: 'Raleway',
      url: 'https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap',
    },
    {
      value: 'Oswald',
      url: 'https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600&display=swap',
    },
    {
      value: 'Montserrat',
      url: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap',
    },
    {
      value: 'Poppins',
      url: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap',
    },
    {
      value: 'Work Sans',
      url: 'https://fonts.googleapis.com/css2?family=Work+Sans:wght@400;500;600&display=swap',
    },
    {
      value: 'Archivo',
      url: 'https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;600&display=swap',
    },
    {
      value: 'Merriweather',
      url: 'https://fonts.googleapis.com/css2?family=Merriweather:wght@400;500;600&display=swap',
    },
    {
      value: 'Open Sans',
      url: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600&display=swap',
    },
    {
      value: 'Source Sans Pro',
      url: 'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;500;600&display=swap',
    },
    { value: 'Arial', url: 'Built-In' },
    { value: 'Comic Sans MS', url: 'Built-In' },
    { value: 'Lucida', url: 'Built-In' },
    { value: 'Tahoma', url: 'Built-In' },
    { value: 'Times New Roman', url: 'Built-In' },
    { value: 'Trebuchet MS', url: 'Built-In' },
    { value: 'Verdana', url: 'Built-In' },
  ].sort((x, y) => {
    if (x.value > y.value) return 1;
    if (x.value < y.value) return -1;
    return 0;
  });

  public rideTypeOptions = [
    {
      type: 'road',
      defaultImage:
        'https://images.unsplash.com/photo-1517649763962-0c623066013b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670&q=80',
    },
    {
      type: 'mountain',
      defaultImage:
        'https://images.unsplash.com/photo-1562862570-d9e821847237?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2623&q=80',
    },
    {
      type: 'social',
      defaultImage:
        'https://images.unsplash.com/photo-1552434195-d7e9db6cacd8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2940&q=80',
    },
    {
      type: 'bmx',
      defaultImage:
        'https://images.unsplash.com/photo-1576282987851-a4b69fe4e767?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2940&q=80',
    },
    {
      type: 'e-bike',
      defaultImage:
        'https://images.unsplash.com/photo-1563990308267-cd6d3cc09318?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    },
    {
      type: 'gravel',
      defaultImage:
        'https://images.unsplash.com/photo-1632059831875-0aa337739a06?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2950&q=80',
    },
  ].sort((x, y) => {
    if (x.type > y.type) return 1;
    if (x.type < y.type) return -1;
    return 0;
  });

  constructor(
    private appConfig: AppConfig,
    private fb: FormBuilder,
    private shopRidesService: ShopRidesService,
    public messageService: MessageService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    private helper: HelpersService,
    private sanitizer: DomSanitizer,
    private rentalsService: RentalsService
  ) { }

  ngOnInit() {
    
    this.getConfig();
    this.getRentalProducts();    
    this.fontOptions.forEach((font) => {
      if (font.url.indexOf('https://') > -1) {
        const head = document.getElementsByTagName('head')[0];
        const style = document.createElement('link');
        style.id = 'css-styling';
        style.rel = 'stylesheet';
        style.href = font.url;
        head.appendChild(style);
      }
    });
  }

  getConfig() {
    this.loading = true;
    this.shopRidesService
      .getShopRideWidgetConfig(this.helper.getPartnerId())
      .subscribe(
        (config) => {
          this.config = config.configuration;
          this.partnerIdentifier = config.partnerIdentifier;
          this.parentIdentifier = config.parentIdentifier;

          this.createLink();

          this.setupValidation();
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  setupValidation() {
    this.configForm = this.fb.group({
      useSettingForAllLinkedStores: new FormControl(
        this.config.useSettingForAllLinkedStores || false,
        Validators.nullValidator,
      ),
      cardBackground: new FormControl(
        this.config.cardBackground || '#ececec',
        Validators.nullValidator,
      ),
      defaultBackgroundColor: new FormControl(
        this.config.defaultBackgroundColor || '#ffffff',
        Validators.nullValidator,
      ),
      primaryColor: new FormControl(
        this.config.primaryColor || '#313132',
        Validators.nullValidator,
      ),
      primaryTextColor: new FormControl(
        this.config.primaryTextColor || '#454545',
        Validators.nullValidator,
      ),
      cardBorderRadius: new FormControl(
        this.config.cardBorderRadius != null
          ? this.config.cardBorderRadius
          : 16,
        Validators.nullValidator,
      ),
      headerLabel: new FormControl(
        this.config.headerLabel,
        Validators.nullValidator,
      ),
      joinRideLabel: new FormControl(
        this.config.joinRideLabel,
        Validators.nullValidator,
      ),
      emptyListLabel: new FormControl(
        this.config.emptyListLabel,
        Validators.nullValidator,
      ),
      customText: new FormControl(
        this.config.customText,
        Validators.nullValidator,
      ),
      customTextPositionAboveButton: new FormControl(
        this.config.customTextPositionAboveButton,
        Validators.nullValidator,
      ),
      defaultFont: new FormControl(
        this.config.defaultFont ||
        'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap',
        Validators.nullValidator,
      ),
      defaultFontName: new FormControl(
        this.config.defaultFontName || 'Montserrat',
        Validators.nullValidator,
      ),
      secondaryFont: new FormControl(
        this.config.secondaryFont ||
        'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;500;600&display=swap',
        Validators.nullValidator,
      ),
      secondaryFontName: new FormControl(
        this.config.secondaryFontName || 'Source Sans Pro',
        Validators.nullValidator,
      ),
      showRentalOptionFromWidget: new FormControl(
        this.config.showRentalOptionFromWidget || false,        
        Validators.nullValidator,
      )
    });    
    this.checkIfRentalSubscription();
  }

  onQuillEditorCreated(editor) {
    editor.root.addEventListener('blur', () => {
      //this.updateURL();
    });
  }

  updateColor(event, field) {
    console.log(event);
    console.log(field);
    switch (field) {
      case 'primaryColor':
        this.configForm.controls['primaryColor'].setValue(event);
        break;
      case 'primaryTextColor':
        this.configForm.controls['primaryTextColor'].setValue(event);
        break;
      case 'cardBackground':
        this.configForm.controls['cardBackground'].setValue(event);
        break;
      case 'defaultBackgroundColor':
        this.configForm.controls['defaultBackgroundColor'].setValue(event);
        break;
    }
  }

  updateFont(event) {
    this.configForm.controls['defaultFont'].setValue(event.url);
    this.configForm.controls['defaultFontName'].setValue(event.value);
  }

  updateSecondaryFont(event) {
    this.configForm.controls['secondaryFont'].setValue(event.url);
    this.configForm.controls['secondaryFontName'].setValue(event.value);
  }

  async updateRideTypePoster(event, rideType) {
    console.log(rideType);
    console.log(event);
    var file = event.target.files[0];
    var fileData = await this.readFileAsync(file);

    var data = {
      PartnerID: this.helper.getPartnerId(),
      Image: fileData.toString().replace(/^data:(.*;base64,)?/, ''),
    };
    console.log(data);
    this.shopRidesService.addShopRidePosterImage(data).subscribe((result) => {
      switch (rideType) {
        case 'bmx':
          this.config.defaultBmxPoster = result.imageURL;
          break;
        case 'road':
          this.config.defaultRoadPoster = result.imageURL;
          break;
        case 'mountain':
          this.config.defaultMountainPoster = result.imageURL;
          break;
        case 'social':
          this.config.defaultSocialPoster = result.imageURL;
          break;
        case 'gravel':
          this.config.defaultGravelPoster = result.imageURL;
          break;
        case 'e-bike':
          this.config.defaultEbikePoster = result.imageURL;
          break;
      }
    });
  }

  readFileAsync(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result.toString());
      };
      reader.onerror = reject;
    });
  }

  getPosterImage(rideType: any) {
    switch (rideType.type) {
      case 'bmx':
        return this.config.defaultBmxPoster || rideType.defaultImage;
        break;
      case 'road':
        return this.config.defaultRoadPoster || rideType.defaultImage;
        break;
      case 'mountain':
        return this.config.defaultMountainPoster || rideType.defaultImage;
        break;
      case 'social':
        return this.config.defaultSocialPoster || rideType.defaultImage;
        break;
      case 'gravel':
        return this.config.defaultGravelPoster || rideType.defaultImage;
        break;
      case 'e-bike':
        return this.config.defaultEbikePoster || rideType.defaultImage;
        break;
    }
  }

  getWidgetURL() {
    return this.iFrameLink;
  }

  saveConfig(config) {
    var data = { ...this.config, ...config };
    
    if (data.partnerID == 0) {
      data.partnerID = this.helper.getPartnerId();
    }

    this.saving = true;
    this.shopRidesService.updateShopRideWidgetConfig(data).subscribe(
      (res) => {
        this.config = res;
        this.createLink();
        this.saving = false;
      },
      (err) => {
        this.saving = false;
      },
    );
  }

  createLink() {
    this.iFrameCreated = false;
    if (this.parentIdentifier && this.config.useSettingForAllLinkedStores) {
      this.dangerousURL =
        this.appConfig.getShopRideURL() +
        '/group-rides/stores/' +
        this.parentIdentifier +
        (this.appConfig.isDev() ? '?dev=true' : ''); 
    } else {
      this.dangerousURL =
        this.appConfig.getShopRideURL() +
        '/group-rides/store/' +
        this.partnerIdentifier +
        (this.appConfig.isDev() ? '?dev=true' : '');
    }
    
    this.iFrameSizer = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.appConfig.getShopRideURL() + '/assets/js/iframeSizer.min.js',
    );
    this.iFrameLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.dangerousURL,
    );
    this.iFrameCreated = true;
  }

  copyLink() {
    let anyNavigator: any;
    anyNavigator = window.navigator;
    anyNavigator.clipboard.writeText(this.dangerousURL).then(() => {
      this.messageService.add({
        life: 5000,
        detail: this.translate.instant(
          'bikeshop.shop_ride_configuration.link_copied',
        ),
        key: 'link-copied',
      });
    });
  }

  copyiFrame() {
    var iframe = `<div style="width: 100%;">
    <style>
      iframe {
          width: 1px;
          min-width: 100%;
          border-width: 0px;
          height: 1500px;
      }
      </style>
        <script type="text/javascript" src="${this.appConfig.getShopRideURL() + '/assets/js/iframeSizer.min.js'}"></script>
        <iframe id="shop-rides-iframe" src="${this.dangerousURL}" allow="geolocation"></iframe>
        <script>
            iFrameResize({ log: false}, '#shop-rides-iframe' );
        </script>
    </div>`;

    let anyNavigator: any;
    anyNavigator = window.navigator;
    anyNavigator.clipboard.writeText(iframe).then(() => {
      this.messageService.add({
        life: 5000,
        detail: this.translate.instant(
          'bikeshop.shop_ride_configuration.iframe_copied',
        ),
        key: 'link-copied',
      });
    });
  }

  getRentalProducts() {
    this.rentalsService.getRentalProducts(this.helper.getPartnerId()).subscribe((res) => {
      const uniqueCategories = new Map();
      res.filter(x => { return x.isRental }).forEach(x => uniqueCategories.set(x.categoryID, { value: x.categoryID, label: x.categoryName }));
      this.productCategories = Array.from(uniqueCategories.values())
        .sort((a, b) => a.label.localeCompare(b.label));

      this.productGroups = res.filter(x => { return x.isRental }).map(x => { return { value: this.getProductIdentifierValue(x.rentalProducts), label: x.brand + " " + x.model } });
      
      this.getLinkedRentalCategories();
      this.getLinkedRentalProducts();
    });
  }

  getProductIdentifierValue(rentalProducts: any) {
    if (rentalProducts && rentalProducts.length > 0) {
      const identifier = rentalProducts[0].identifier;
      const trimmedIdentifier = identifier.substring(0, identifier.lastIndexOf('_'));
      return trimmedIdentifier
    }
    return null;
  }

  getLinkedRentalCategories() {
    this.shopRidesService.getRideRentalCategoryLinks(this.helper.getPartnerId()).subscribe((res) => {
      this.linkedCategories = res;
    }, (err) => {
    });
  }

  getLinkedRentalProducts() {
    this.shopRidesService.getRideRentalProductLinks(this.helper.getPartnerId()).subscribe((res) => {
      this.linkedProducts = res;
    }, (err) => {
    });
  }

  linkRentalCategory(){
    if(this.linkingRentalCategory) return;

    this.linkingRentalCategory = true;
    var data = {
      PartnerID: this.helper.getPartnerId(),
      RentalCategoryID: this.selectedProductCategory,
      RideType: this.selectedCategoryRideType
    }
    this.shopRidesService.createRideRentalCategoryLink(data).subscribe((res) => {
      this.getLinkedRentalCategories();
      this.selectedProductCategory = null;
      this.selectedCategoryRideType = null;
      this.linkingRentalCategory = false;
    }, (err) => {
      this.linkingRentalCategory = false;
    })
  }

  removeLinkedCategory(item){
    item.unlinking = true;
    this.shopRidesService.deleteShopRideRentalCategoryLink(this.helper.getPartnerId(), item.id).subscribe((res) => {
      this.getLinkedRentalCategories();
    }, (err) => {
      item.unlinking = false;
    });
  }


  getCategory(id : any){
    const category = this.productCategories.find((x: any) => x.value == id);
    if (category) {
      return category.label;
    }
    return '';
  }

  linkRentalProduct(){
    if(this.linkingProduct) return;
    
    this.linkingProduct = true;
    var data = {
      PartnerID: this.helper.getPartnerId(),
      RentalProductIdentifier: this.selectedProductGroup,
      RideType: this.selectedProductRideType
    }
    this.shopRidesService.createRideRentalProductLink(data).subscribe((res) => {
      this.getLinkedRentalProducts();
      this.selectedProductGroup = null;
      this.selectedProductRideType = null;
      this.linkingProduct = false;
    }, (err) => {
      this.linkingProduct = false;
    })
  }

  removeLinkedProduct(item){
    item.unlinking = true;
    this.shopRidesService.deleteShopRideRentalProductLink(this.helper.getPartnerId(), item.id).subscribe((res) => {
      this.getLinkedRentalProducts();
    }, (err) => {
      item.unlinking = false;
    });
  }

  getProduct(id : any){
    const product = this.productGroups.find((x: any) => x.value == id);
    if (product) {
      return product.label;
    }
    return '';
  }

  checkIfRentalSubscription() {
    var subscriptions = this.helper.getPartnerData().SubscribedProducts;
    if(subscriptions && subscriptions.length > 0 && subscriptions.find(x => x.ProductType === "RENTALS" && (x.StatusID !== 2 || x.StatusID != 21))){ 
      this.configForm.controls['showRentalOptionFromWidget'].enable();
    }else{
      this.configForm.controls['showRentalOptionFromWidget'].setValue(false);
      this.configForm.controls['showRentalOptionFromWidget'].disable();

    }
  }

}


